import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const quickLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Faqs', path: '/faqs' },
    { name: 'Blogs', path: '/blogs' },
    { name: 'Contact Us', path: '/contact' }
  ];

  const services = [
    { name: 'Web Development', path: '/web-development' },
    { name: 'Mobile App', path: '/mobile-app' },
    { name: 'Software Development', path: '/software-development' },
    { name: 'E-Commerce', path: '/ecommerce' },
    { name: 'Blockchain', path: '/blockchain' },
    { name: 'UI/UX Design', path: '/ui-ux-design' },
    { name: '3D Animation', path: '/3d-animation' },
    { name: 'Cloud Solutions', path: '/cloud-solutions' },
    { name: 'Marketing', path: '/marketing' },
    { name: 'Copywriting', path: '/copywriting' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <Link to="/" className="inline-flex items-center mb-4">
              <img src="/logo.png" alt="Invotage LLC" className="h-12 w-auto" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Invotage is your trusted partner for digital transformation. We deliver innovative, scalable technology solutions that drive business growth, enhance customer experiences, and position your brand for long-term success in the digital age.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-400 hover:text-purple-500 text-sm transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Services</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-gray-400 hover:text-purple-500 text-sm transition-colors"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-purple-500 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">info@invotage.com</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-purple-500 mt-0.5 flex-shrink-0" />
                <span className="text-gray-400 text-sm">
                  11040 Santa Monica Blvd #310, Los Angeles, CA 90025
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">2026 Invotage | All Rights Reserved</p>
            <div className="flex space-x-6">
              <Link to="/privacy" className="text-gray-400 hover:text-purple-500 text-sm">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-purple-500 text-sm">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;